export default __webpack_public_path__ + "static/media/Clown-auf-Rad.2fe1d8c3.webp";